var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6C0208D9-CCFB-4180-801E-34CC9A114298") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 28,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Theme-Setup",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sticker-Sheet",
    transform: "translate(-670.000000, -740.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/ascending-Copy-14",
    transform: "translate(670.000000, 740.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "2 2 26 2 26 26 2 26"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Hover-Style"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "State"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.208,22 C20.6915556,22 21.1111111,21.8222222 21.4666667,21.4666667 C21.8222222,21.1111111 22,20.6915556 22,20.208 L22,20.208 L22,9.11466667 C22,8.91555556 21.9608889,8.71644444 21.8826667,8.51733333 C21.8044444,8.31822222 21.7084444,8.14755556 21.5946667,8.00533333 L21.5946667,8.00533333 L20.3786667,6.49066667 C20.08,6.16355556 19.7315556,6 19.3333333,6 L19.3333333,6 L8.66666667,6 C8.46755556,6 8.27555556,6.04622222 8.09066667,6.13866667 C7.90577778,6.23111111 7.74933333,6.34844444 7.62133333,6.49066667 L7.62133333,6.49066667 L6.42666667,8.00533333 C6.29866667,8.14755556 6.19555556,8.31822222 6.11733333,8.51733333 C6.03911111,8.71644444 6,8.91555556 6,9.11466667 L6,9.11466667 L6,20.208 C6,20.6915556 6.17777778,21.1111111 6.53333333,21.4666667 C6.88888889,21.8222222 7.30844444,22 7.792,22 L7.792,22 L20.208,22 Z M20.1226667,7.792 L7.87733333,7.792 L8.624,6.87466667 L19.2906667,6.87466667 L20.1226667,7.792 Z M14,18.864 L9.136,14 L12.208,14 L12.208,12.208 L15.792,12.208 L15.792,14 L18.8853333,14 L14,18.864 Z",
    id: "Icon-Color",
    fill: "#50566E"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.9fdbc285d63e42bee2bd3ddec45b5dee.svg";
export { ForwardRef as ReactComponent };